import { useEffect, useReducer } from "react";
import incrementWithLeadingZeros from "./incrementWithLeadingZeros";


let myOrder = {
  status: 'new',
    is_ordered: false,
    is_selected: true,
    customer_id: '',
    receipt_number: '',
    order_ref: '',
    delivery_region_id: '',
    is_refund: false,
    note: '',
    pick_later: false,
    demand_sold: false,
    orderlines: [],
    paymentLines: [],
    createdAt: '',
    user_id: ''
  
}


const initialState = {
  orders: [],
  employee_id: null,
  session_id: null,
  pos_id: null
}



const reducer = (state, action) => {
  let orders = [...state.orders];
  let order_index = orders.findIndex(order => order.is_selected === true);

  
  switch (action.event) {

    case 'LOAD_SESSION_ORDERS':
      let pos = localStorage.getItem('caspian_pos_session');
      let pos_ = JSON.parse(pos);
      // pos_.orders[0].status = 'paid';
      // pos_[1].is_selected = true;
      // pos_.orders[0].orderlines = [];
      // localStorage.setItem('caspian_pos_session', JSON.stringify(pos_));
      state = pos_;
      return {...state};

    // case 'LOAD_SESSION_ORDER':
    //   let orders = [...state.orders];
    //   let order_index = orders.findIndex(order => order.is_selected === true);
  
    //   let order = orders.find(order => order.is_selected === true);
    //   return {...state, selectedOrder: order};

    // case 'TESTING':
    //   return {...state, message: 'AM TESTING THE REDUCER'}
    
    case 'ADD_CART':
      orders[order_index].orderlines = action.item;
      state.orders = orders;
      localStorage.setItem('caspian_pos_session', JSON.stringify(state));
      return { ...state }



    case 'UPDATE_QUANTITY':
    case 'SELECT_ORDER_LINE':
      orders[order_index].orderlines = action.items;
      state.orders = orders;
      localStorage.setItem('caspian_pos_session', JSON.stringify(state));
      return {...state }

    case 'ADD_NOTE':
      orders[order_index].note = action.note;
      state.orders = orders;
      localStorage.setItem('caspian_pos_session', JSON.stringify(state));
      return {...state}

    case 'ADD_DELIVERY_REGION':
      orders[order_index].delivery_region_id = action.delivery_region;
      state.orders = orders;
      localStorage.setItem('caspian_pos_session', JSON.stringify(state));
      return {...state};
    
    case 'MARK_ORDER':
    case 'MAKE_PAYMENT':
      orders[order_index] = action.item;
      // console.log(orders[order_index])
      state.orders = orders;
      localStorage.setItem('caspian_pos_session', JSON.stringify(state));
      return {...state};

    case 'ADD_CUSTOMER':
      const { id, name } = action.customer;
      orders[order_index].customer_id = id;
      orders[order_index].cus_name = name;
      state.orders = orders;
      localStorage.setItem('caspian_pos_session', JSON.stringify(state));
      return {...state};

    case 'NEW_ORDER':
      state.orders = action.orders;
      localStorage.setItem('caspian_pos_session', JSON.stringify(state));
      return {...state};

    case 'SELECT_ORDER':
    case 'PICKING_STATE':
      // orders[order_index].is_selected = false;
      // orders[action.index].is_selected = true;
      // console.log(orders)
      state.orders = action.orders;
      localStorage.setItem('caspian_pos_session', JSON.stringify(state));
      return {...state};

    case 'REMOVE_ORDER':
      state.orders = action.orders;
      localStorage.setItem('caspian_pos_session', JSON.stringify(state));
      return {...state};

    // case 'PICKING_STATE':
    //   state.orders = action.orders;
    //   localStorage.setItem('caspian_pos_session', JSON.stringify(state));
    //   return {...state};
  }
};

export const getOrderTotal = (array) => array?.reduce((prev, current) => (((current.sales_price * (current.quantity*1).toFixed(2)) + prev * 1) * 1).toFixed(2), 0);
export const getTaxOrderTotal = (array) => array?.reduce((prev, current) => (current.tax * 1 + prev * 1), 0);
export const getPaymentTotal = (array) => array?.reduce((prev, current) => (((current.sales_price * (current.quantity*1).toFixed(2))+ prev * 1) * 1).toFixed(2), 0);

const usePosSessionReducer = (user) => {

  const getOrder = orders => orders.find(order => order.is_selected === true);

  const createNewOrder = (state, user_id) => {
    let orders = [...state.orders];
    const lastOrder = orders.reduce((latestObj, currentObj) => {
      return new Date(currentObj.createdAt) > new Date(latestObj.createdAt) ? currentObj : latestObj;
    }, orders[0]);
    // console.log(lastOrder)
    orders.forEach((_, idx) => orders[idx].is_selected = false);
    let receipt_no = lastOrder.receipt_number.split('-');
    let code = lastOrder['order_ref'].split('/');
    let number = incrementWithLeadingZeros(code[code.length - 1], 5);
    let receiptNumber = incrementWithLeadingZeros(receipt_no[receipt_no.length - 1], 5);
    code[code.length - 1] = number;
    let code_ = code.join('/');
    receipt_no[receipt_no.length - 1] = receiptNumber;
    let receipt_ = receipt_no.join('-');
    let newOrder = {
      status: 'new',
      is_ordered: false,
      is_selected: true,
      customer_id: '',
      receipt_number: receipt_,
      order_ref: code_,
      delivery_region_id: '',
      is_refund: false,
      note: '',
      pick_later: false,
      sell_demand: false,
      orderlines: [],
      paymentLines: [],
      createdAt: Date.now(),
      user_id
    };
    orders.push(newOrder);
    return orders;
  }
  
  const removeOrder = (orders, order_createdAt) => {
    let index = orders.findIndex(order => order.createdAt === order_createdAt);
    if (index > -1) {
      orders.splice(index, 1);
      orders[orders.length - 1].is_selected = true;
      console.log(orders[orders.length - 1])  
      return orders;
    }
  }

  // useEffect(() => {
  //   if (state.orders !== undefined || state.orders.length === 0) {
  //     myOrder.user_id = user.id;
  //     dispatch({event: 'NEW_ORDER', orders: [myOrder]});
  //   }
  // },[])

  const [state, dispatch] = useReducer(reducer, initialState);

  return { state, dispatch, getOrder, getOrderTotal, createNewOrder, removeOrder };
}

export default usePosSessionReducer;